import React, {useEffect, useState} from "react";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import {ReactComponent as BusModeIcon} from "../../assets/busMode.svg";
import {ReactComponent as BicycleModeIcon} from "../../assets/bicycleMode.svg";
import {ReactComponent as WalkModeIcon} from "../../assets/walkMode.svg";
import {ReactComponent as CarModeIcon} from "../../assets/carMode.svg";
import {ReactComponent as BusModeSelectedIcon} from '../../assets/busModeSelected.svg'
import {ReactComponent as BicycleModeSelectedIcon} from '../../assets/bicycleModeSelected.svg'
import {ReactComponent as WalkModeSelectedIcon} from '../../assets/walkModeSelected.svg'
import {ReactComponent as CarModeSelectedIcon} from '../../assets/carModeSelected.svg'
import {JOURNEY_MODES} from '../../constants';
import {settingQueryParam} from "../../actions/form";
import {connect} from "react-redux";
import {routingQuery} from "../../actions/api";
import {setMainPanelContent} from "../../actions/ui";

function JourneyBar(props) {
  const {modeRoute} = props;
  const getMode = () => {
    return modeRoute.includes('TRANSIT') ? JOURNEY_MODES.bus : modeRoute;
  };
  const [selectedMode, setSelectedMode] = useState(getMode());

  useEffect(() => {
    setSelectedMode(getMode());
  }, [modeRoute]);

  const selectedModeClick = (mode) => {
    if (mode !== selectedMode) {
      setSelectedMode(mode);
      if (mode !== JOURNEY_MODES.bus) {
        props.settingQueryParam({mode: mode});
      } else {
        props.settingQueryParam({mode: 'WALK,TRANSIT'});
      }

      props.setMainPanelContent(null);
      props.routingQuery();
    }
  };

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs display="flex" justifyContent="center" alignItems="center">
          <IconButton onClick={c => selectedModeClick(JOURNEY_MODES.bus)}>
            {selectedMode === JOURNEY_MODES.bus ? (<BusModeSelectedIcon/>) : (<BusModeIcon/>)}
          </IconButton>
        </Grid>
        <Grid item xs display="flex" justifyContent="center" alignItems="center">
          <IconButton onClick={c => selectedModeClick(JOURNEY_MODES.bicycle)}>
            {selectedMode === JOURNEY_MODES.bicycle ? (<BicycleModeSelectedIcon/>) : (<BicycleModeIcon/>)}
          </IconButton>
        </Grid>
        <Grid item xs display="flex" justifyContent="center" alignItems="center">
          <IconButton onClick={c => selectedModeClick(JOURNEY_MODES.walk)}>
            {selectedMode === JOURNEY_MODES.walk ? (<WalkModeSelectedIcon/>) : (<WalkModeIcon/>)}
          </IconButton>
        </Grid>
        <Grid item xs display="flex" justifyContent="center" alignItems="center">
          <IconButton onClick={c => selectedModeClick(JOURNEY_MODES.car)}>
            {selectedMode === JOURNEY_MODES.car ? (<CarModeSelectedIcon/>) : (<CarModeIcon/>)}
          </IconButton>
        </Grid>
      </Grid>
    </>
  )

}

const mapStateToProps = (state, ownProps) => {
  return {
    modeRoute: state.otp.currentQuery.mode,
    currentQuery: state.otp.currentQuery
  }
};
const mapDispatchToProps = {
  settingQueryParam,
  routingQuery,
  setMainPanelContent
};
export default connect(mapStateToProps, mapDispatchToProps)(JourneyBar)